import * as React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const HomeFeatured = () => {
  const data = useStaticQuery(graphql`
    query MyQuery {
      sanitySiteSettings {
        id
        featuredTrailers {
          id
          title
          heroText
          slug {
            current
          }
          category {
            id
            slug {
              current
            }
          }
          imageRealLife {
            asset {
              gatsbyImageData(
                layout: FULL_WIDTH
                placeholder: BLURRED
                width: 558
              )
            }
          }
        }
      }
    }
  `)

  return (
    <section className={"bg-grey-100 py-16"}>
      <div className={"max-w-6xl mx-auto px-6 md:px-4"}>
        <h2 className={"text-3xl text-navy font-bold mb-4"}>
          Featured Trailers
        </h2>

        <div className={"grid md:grid-cols-2 gap-6"}>
          {data.sanitySiteSettings.featuredTrailers.map((trailer, index) => (
            <div
              key={trailer.id}
              className={`group relative w-full h-64 bg-grey overflow-hidden ${
                index === 0 ? "md:row-span-2 h-60 md:h-auto" : "h-60"
              }`}
            >
              <Link
                to={
                  "/trailers/" +
                  (trailer.category ? trailer.category.slug.current + '/' : "") +
                  trailer.slug.current
                }
              >
                <GatsbyImage
                  alt={trailer.imageRealLife.asset.alt}
                  image={trailer.imageRealLife.asset.gatsbyImageData}
                  className={
                    "absolute w-full h-full transition duration-500 group-hover:scale-105"
                  }
                />

                <div
                  className={`p-3 bg-navy absolute bottom-8 right-8 ${
                    index === 0 ? "w-56 md:w-80" : "w-56"
                  }`}
                >
                  <h3 className={"text-white font-semibold text-xl mb-2"}>
                    {trailer.title}
                  </h3>
                  {index === 0 && (
                    <p className={"text-white text-sm hidden md:block"}>
                      {trailer.heroText}
                    </p>
                  )}

                  <span
                    className={
                      "bg-white flex justify-between px-3 py-2 text-navy font-bold"
                    }
                  >
                    View Trailer
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      ></path>
                    </svg>
                  </span>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HomeFeatured
